<template>
	<div class="col-md-12">
		<div
            v-if="errorMessage"
			class="modal fade bd-example-modal-md show"
			tabindex="-1"
			role="dialog"
			aria-labelledby="mySmallModalLabel"
			style="display: block; padding-right: 15px"
		>
			<div class="modal-dialog modal-md">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title color-red" id="mySmallModalLabel">
							{{errorMessage}}
						</h4>
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true" @click.prevent="clearErrors">×</span>
						</button>
					</div>
					<div class="modal-body">
                        <ul>
                            <li v-for="(error, idx) in errors" :key="idx">
                                {{error}}
                            </li>
                        </ul>
                    </div>
				</div>
			</div>
		</div>
		<div id="accordion">
			<div class="card">
				<div class="card-header" id="headingOne">
					<h5 class="mb-0">
						<button
							class="btn btn-link text-center"
							data-toggle="collapse"
							data-target="#collapseOne"
							aria-expanded="true"
							aria-controls="collapseOne"
							style="width: 100%"
						>
							Music
						</button>
					</h5>
				</div>
				<div
					id="collapseOne"
					class="collapse"
					aria-labelledby="headingOne"
					data-parent="#accordion"
				>
					<div class="card-body">
						<form class="row">
							<div
								class="form-group col-md-3"
								v-for="(field, idx) in songFields"
								:key="idx"
							>
								<label for="exampleInputEmail1">
									{{ field.label }}
								</label>
								<input
									v-model="song[field.slug]"
									:type="field.type"
									class="form-control"
									:placeholder="field.placeholder"
								/>
							</div>
						</form>
						<div class="row">
							<div class="col-md-6"></div>
							<div class="col-md-6 text-right">
								<button
									@click="addSong"
									class="btn btn-success mb-2 border-2"
								>
									Add song
								</button>
								<label class="btn btn-primary mb-2 border-2">
									Upload excel (xlsx)
									<input
										class="btn btn-success mb-2 border-2"
										type="file"
										@input="handleExcel"
										:value="file"
										hidden
									/>
								</label>
							</div>
						</div>
						<div class="row" v-if="songs && songs.length">
							<div class="col-md-12 table-responsive">
								<table class="table">
									<caption>
										Number of songs:
										{{
											songs.length
										}}
									</caption>
									<thead>
										<tr>
											<th
												scope="col"
												v-for="(
													field, idx
												) in songFields"
												:key="idx"
											>
												{{ field.label }}
											</th>
											<th>Actions</th>
										</tr>
									</thead>
									<tbody>
										<tr
											v-for="(song, idx) in songs"
											:key="idx"
										>
											<td
												v-for="(
													field, index
												) in songFields"
												:key="index"
											>
												<span
													v-if="editing !== song.id"
												>
													{{ song[field.slug] || "" }}
												</span>
												<input
													class="form-control"
													width="100%"
													v-model="song[field.slug]"
													:type="field.type"
													v-else
												/>
											</td>
											<td class="clickable-actions">
												<span class="text-primary">
													<span
														v-if="!editing"
														@click="
															editing = song.id
														"
													>
														Edit
													</span>
													<span
														v-if="
															editing === song.id
														"
														@click="updateSong(idx)"
													>
														Save
													</span>
												</span>
												<span
													@click="deleteSong(song.id)"
													class="text-danger"
												>
													Delete
												</span>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { songFields } from "./data.js";
import XLSX from "xlsx";

export default {
	props: {
		episodeId: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			song: {},
			songs: [],
			songFields: songFields,
			editing: false,
			file: null,
			errorMessage: null,
			errors: [],
		};
	},
	methods: {
		fetchSongs() {
			axios.get(`/episodes/${this.episodeId}/songs`).then((response) => {
				this.songs = response.data || [];
			});
		},
		addSong() {
			axios
				.post(`/episodes/${this.episodeId}/songs`, this.song)
				.then((response) => {
					this.songs = response.data || [];
					this.song = {};
				})
				.catch((error) => {
					if (error.response.status === 422) {
						this.showValidationError(error);
					} else {
						alert(
							"Failed to save! Please check your input and try again."
						);
					}
					console.error(error);
				});
		},
		updateSong(index) {
			const song = this.songs[index];
			axios
				.put(`/episodes/${this.episodeId}/songs/${song.id}`, song)
				.then((response) => {
					this.songs = response.data || [];
					this.editing = false;
				})
				.catch((error) => {
					if (error.response.status === 422) {
						this.showValidationError(error);
					} else {
						alert(
							"Failed to save! Please check your input and try again."
						);
					}
					console.error(error);
				});
		},
		deleteSong(id) {
			if (!confirm("Please confirm to delete the song")) {
				return;
			}

			axios
				.delete(`/episodes/${this.episodeId}/songs/${id}`)
				.then((response) => {
					this.songs = response.data || [];
				})
				.catch((error) => {
					alert("Failed to delete!");
					console.error(error);
				});
		},
		saveExcelData(data) {
			axios
				.post(`/episodes/${this.episodeId}/songs/excel`, {
					songs: data,
				})
				.then((response) => {
					this.songs = response.data || [];
					this.file = null;
				})
				.catch((error) => {
					this.file = null;
					if (error.response.status === 422) {
						this.showValidationError(error);
					} else {
						alert(
							"Failed to save! Please check your file and try again."
						);
					}
					console.error(error);
				});
		},
		handleExcel(e) {
			const files = e.target.files;
			const file = files[0];

			if (!file) {
				return;
			}

			const reader = new FileReader();
			const self = this;
			let jsonArray = [];

			reader.onload = function (e) {
				let data = new Uint8Array(e.target.result);
				let workbook = XLSX.read(data, { type: "array" });
				let worksheet = null;

				workbook.SheetNames.forEach((sheetName) => {
					worksheet = workbook.Sheets[sheetName];
					jsonArray = jsonArray.concat(
						XLSX.utils.sheet_to_json(worksheet)
					);
				});

				self.saveExcelData(jsonArray);
			};

			reader.readAsArrayBuffer(file);
		},
		showValidationError(error) {
			this.errorMessage = error.response.data.message;
			const errors = error.response.data.errors;

			if (errors && typeof errors === "object") {
				Object.keys(errors).forEach((key) => {
					this.errors.push(errors[key][0]);
				});
			}
		},
        clearErrors() {
            this.errorMessage = null
            this.errors = []
        }
	},
	mounted() {
		this.fetchSongs();
	}
};
</script>

<style lang="scss" scoped>
.clickable-actions {
	span {
		padding-left: 5px;
		cursor: pointer;
	}
}

#headingOne {
	h3,
	button {
		text-decoration: none !important;
	}
}

.color-red {
    color: #c00 !important;
}
</style>
